import FetchData from '../Components/ServerCall/FetchData';
import Cookies from 'js-cookie';
import { FlatFileSaveFileOBJ } from '../redux/FlatFile/FlatFileInterfaces';
import { SampleRecordesColumnType } from '../redux/SampleTableRecords/SampleTableRecordsInterfaces';

export const onEditFlatFileResults = async (file: any, parentId: string | undefined) => {
  const columnResult = await FetchData({
    requestType: 'noData',
    method: 'POST',
    url: `file-data-column-details?workspaceId=${parentId}&flatfileId=${file.id}`,
    headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
  });
  if (!columnResult.status)
    return { isError: true, message: 'Failed to fetch column details', data: null };

  const sampleResult = await FetchData({
    requestType: 'noData',
    method: 'POST',
    url: `file-data-sample-records?flatfileId=${file.id}&workspaceId=${parentId}`,
    headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
  });
  if (!sampleResult.status)
    return { isError: true, message: 'Failed to fetch sample records', data: null };

  const fileObj = {
    fileId: file.id as string,
    name: file.name as string,
    dateFormat: file.dateFormat as string,
    timestampFormat: file.timestampFormat,
    columnInfos: columnResult.data,
    sampleRecords: sampleResult.data,
  };
  return {
    isError: false,
    message: 'Fetched successfully',
    data: fileObj,
  };
};

export const setDataToEditApiResponseResult = async (
  parentId: string | undefined,
  fileObj: FlatFileSaveFileOBJ,
) => {
  const result = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `file-upload-change-schema?workspaceId=${parentId}`,
    data: fileObj,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'application/json',
    },
  });

  return result;
};

export const handleSaveResult = async (formObj: FlatFileSaveFileOBJ, workspaceID: any) => {
  const result = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `file-upload-save-data?workspaceId=${workspaceID}`,
    data: formObj,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'application/json',
    },
  });

  return result;
};

//SheetDialog.tsx Functions
export interface ISampleRecords {
  [key: string]: any;
}
export interface IUploadedData {
  fileId: string;
  name: string;
  columnInfo: SampleRecordesColumnType[];
  sampleRecords: ISampleRecords[];
}
export const SheetDialogResult = async (formData: FormData) => {
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: 'file-upload-excel',
    data: formData,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  if (!res.status)
    return {
      isError: true,
      data: null,
      message: 'No data found',
    };
  return {
    isError: false,
    message: 'fetched successfully',
    data: res.data as IUploadedData,
  };
};

export interface IExcelSheets {
  fileId: string;
  fileName: string;
  sheetNames: string[];
}
//FlatFileUploadHelpers.tsx Functions
export const getExcelSheetNamesResult = async (formData: FormData) => {
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: 'file-upload-excel-sheetname',
    data: formData,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  if (!res.status)
    return {
      isError: true,
      data: null,
      message: 'No data found',
    };
  return {
    isError: false,
    message: 'fetched successfully',
    data: res.data as IExcelSheets,
  };
};

export const uploadFileResult = async (formData: FormData, fileType: string) => {
  const result = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `file-upload?filetype=${fileType}`,
    data: formData,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  if (!result.status)
    return {
      isError: true,
      message: (result.error ?? 'File upload failed') as string,
      data: null,
    };

  return {
    isError: false,
    message: 'File uploaded successfully',
    data: result.data as IUploadedData,
  };
};

export const downloadFlatFile = async (fileId: string) => {
  const result = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `file-download?fileId=${fileId}`,
    headers: {
      Authorization: `Bearer ${Cookies.get('refreshToken')}`,
      'Content-Type': 'application/json',
    },
  });

  if (!result.status)
    return {
      isError: true,
      message: (result.error ?? 'File upload failed') as string,
      data: null,
    };

  return {
    isError: false,
    message: 'Fetched successfully',
    data: result.data,
  };
};

export const updateFlatFile = async (
  formObj: FlatFileSaveFileOBJ,
  workspaceID: string,
  oldFileId: string,
) => {
  const result = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `file-reupload-save-data?workspaceId=${workspaceID}&oldFileId=${oldFileId}`,
    data: formObj,
    headers: {
      Authorization: `Bearer ${Cookies.get('refreshToken')}`,
      'Content-Type': 'application/json',
    },
  });

  if (!result.status || result.responseStatusCode === 417)
    return {
      isError: true,
      message: result.error || 'Something went wrong while updating your data',
      data: result.data as any,
    };

  return {
    isError: false,
    message: 'Data Successfully Updated',
  };
};
export async function getFlatfileTree() {
  const res = await FetchData({
    requestType: 'withData',
    method: 'GET',
    url: `flatfile/tree`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.error ?? 'Failed to get flatfile tree') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Flatfile tree fetched successfully',
    data: res.data,
  };
}
